<h1 mat-dialog-title>{{ 'communications.add.title' | translate }}
  <span [ngClass]="{ 'd-none': !model.subject }"> - {{ model.subject }}</span>
</h1>
<mat-dialog-content class="d-flex">
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

  <!-- MESSAGE AREA -->
  <div class="form-wrapper communication-form doc-communication-form" [ngClass]="showInsertedDocs ? 'col-7' : 'col-12'">
    <form [formGroup]="form">
      <!-- <div class="sender-info-wrapper">
        <div class="sender-label" mat-label>
          {{ 'communications.fields.sender' | translate }}
        </div>
        <span class="sender-email">
          {{ loggedUser.get("email") ? loggedUser.get("email") : '' }}
        </span>
      </div> -->
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
    </form>
  </div>

  <!-- SIDE AREA (hidden when the caller sends attachments only, e.g. a generated document) -->
  <div class="col-5" *ngIf="showInsertedDocs">
    <!-- PHONEBOOK -->
    <!-- <h4>{{ 'communications.fields.phonebook' | translate }}</h4>
    <div *ngIf="filteredRecipients">
      <div class="mb-1 font-italic font-size-sm" *ngIf="!filteredRecipients.length">
        {{ 'common.words.display_no_data' | translate }}
      </div>
      <ng-container *ngFor="let contact of filteredRecipients">
        <div class="text-wrapper">
          <mat-checkbox [checked]="model.chooseRecipient !== 'selected' || contact"
            [disabled]="model.chooseRecipient !== 'selected'" (change)="onContactChanged(contact, $event.checked)"
            class="checkbox-insert">
            <div>
              {{ contact.firstName }} {{ contact.lastName }} ({{ contact.email }})
              - <span class="font-italic font-size-sm">
                {{ 'properties.fields.phonebook.' + contact.type | translate }}</span>
            </div>
          </mat-checkbox>
        </div>
      </ng-container>
      <div>
        <mat-label class="custom-label">{{ 'common.words.other' | translate }}</mat-label>
        <input matInput type="text" id="customContactField"
          placeholder="{{ 'common.cta.insert_separated_by_comma' | translate }}">
        <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Pulisci" (click)="value = ''">
          <mat-icon color="warn" fontSet="fal" fontIcon="fa-times"></mat-icon>
        </button>
      </div>
    </div> -->

    <!-- DOCS -->
    <h4 class="mt-3">{{ 'communications.fields.insertedDocs' | translate }}</h4>
    <div *ngIf="displayedDocs">
      <!-- Checkboxes -->
      <ng-container *ngFor="let doc of model.docs">
        <div class="text-wrapper">
          <!-- <mat-checkbox [checked]="doc.selected" (change)="onDocSelected(doc, $event.checked)" class="checkbox-insert"> -->
          {{ doc.value }}
          <!-- </mat-checkbox> -->
        </div>
      </ng-container>
    </div>
  </div>

</mat-dialog-content>

<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-button (click)="onClose()" mat-raised-button mat-default
      class="ml-3">{{ 'common.cta.close' | translate }}</a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <mat-spinner-button (btnClick)="onFormSubmit(model)" role="submit" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div> <!-- /.col -->
</div> <!-- /.row -->